var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-jumbotron"},[_c('div',[_c('p',{staticClass:"home-jumbotron-h"},[_vm._v("h")])]),_c('div',[_c('p',{staticClass:"home-jumbotron-o"},[_vm._v("o")])]),_c('div',[_c('p',{staticClass:"home-jumbotron-e"},[_vm._v("e")])]),_c('div',[_c('p',{staticClass:"home-jumbotron-y"},[_vm._v("y")])])])
}]

export { render, staticRenderFns }